import React from "react";
import PropTypes from "prop-types";

import Avatar from "@atlaskit/avatar";
import styled from "styled-components";

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  row-gap: 10px;
  padding: 10px 0px;
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
  column-gap: 5px;
`;

const AvatarName = styled.div`
  color: #172b4d;
  font-size: 14px;
`;

function AvatarListDialog({ avatars }) {
  return (
    <ListContainer>
      {avatars.map((avatar) => (
        <ListItem key={avatar.accountId}>
          <Avatar {...avatar} />
          <AvatarName>{avatar.name}</AvatarName>
        </ListItem>
      ))}
    </ListContainer>
  );
}

AvatarListDialog.propTypes = {
  avatars: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AvatarListDialog;
